"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TREE_NODE_HIGHLIGHTS = exports.SCREEN_SIZE_MAP = exports.DATEPICKER_TODAY_ACTIONS_TYPES = exports.OBJECT_STATUS_TYPES = exports.OBJECT_STATUS_SIZES = exports.GridSelector = exports.TAB_SIZES = exports.POPPER_SIZING_TYPES_DESCRIPTION = exports.POPPER_SIZING_TYPES = exports.POPPER_PLACEMENTS = exports.POPOVER_TYPES = exports.IMAGE_TYPES = exports.IMAGE_SIZES = exports.AVATAR_SIZES = exports.ICON_SIZES = exports.FORM_MESSAGE_TYPES = exports.DIALOG_SIZES = exports.COMBOBOX_SELECTION_TYPES = exports.BUTTON_TYPES = exports.BUTTON_OPTIONS = exports.BUSY_INDICATOR_SIZES = exports.MESSAGESTRIP_TYPES = void 0;
var MESSAGESTRIP_TYPES = ['warning', 'error', 'success', 'information'];
exports.MESSAGESTRIP_TYPES = MESSAGESTRIP_TYPES;
var BUSY_INDICATOR_SIZES = ['s', 'm', 'l'];
exports.BUSY_INDICATOR_SIZES = BUSY_INDICATOR_SIZES;
var BUTTON_OPTIONS = ['emphasized', 'transparent'];
exports.BUTTON_OPTIONS = BUTTON_OPTIONS;
var BUTTON_TYPES = ['standard', 'positive', 'negative', 'medium', 'ghost', 'attention'];
exports.BUTTON_TYPES = BUTTON_TYPES;
var COMBOBOX_SELECTION_TYPES = ['manual', 'auto', 'auto-inline'];
exports.COMBOBOX_SELECTION_TYPES = COMBOBOX_SELECTION_TYPES;
var DIALOG_SIZES = ['s', 'm', 'l', 'xl'];
exports.DIALOG_SIZES = DIALOG_SIZES;
var FORM_MESSAGE_TYPES = ['error', 'warning', 'information', 'success'];
exports.FORM_MESSAGE_TYPES = FORM_MESSAGE_TYPES;
var ICON_SIZES = {
  's': '0.75rem',
  'm': '1rem',
  'l': '1.25rem',
  'xl': '1.5rem'
};
exports.ICON_SIZES = ICON_SIZES;
var AVATAR_SIZES = ['xs', 's', 'm', 'l', 'xl'];
exports.AVATAR_SIZES = AVATAR_SIZES;
var IMAGE_SIZES = ['s', 'm', 'l'];
exports.IMAGE_SIZES = IMAGE_SIZES;
var IMAGE_TYPES = ['circle'];
exports.IMAGE_TYPES = IMAGE_TYPES;
var POPOVER_TYPES = [true, 'dialog', 'grid', 'listbox', 'menu', 'tree'];
exports.POPOVER_TYPES = POPOVER_TYPES;
var POPPER_PLACEMENTS = ['auto', 'auto-start', 'auto-end', 'bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'left-end', 'right-start', 'right', 'right-end', 'top-start', 'top', 'top-end'];
exports.POPPER_PLACEMENTS = POPPER_PLACEMENTS;
var POPPER_SIZING_TYPES = ['none', 'matchTarget', 'minTarget', 'maxTarget'];
exports.POPPER_SIZING_TYPES = POPPER_SIZING_TYPES;
var POPPER_SIZING_TYPES_DESCRIPTION = "<ul>\n<li>\"matchTarget\" - left and right edges align with the target</li>\n<li>\"minTarget\" - right edge aligns with target unless Popover content is bigger</li>\n<li>\"maxTarget\" - right edge aligns with target unless Popover content is smaller</li>\n</ul>";
exports.POPPER_SIZING_TYPES_DESCRIPTION = POPPER_SIZING_TYPES_DESCRIPTION;
var TAB_SIZES = ['s', 'm', 'l', 'xl', 'xxl'];
exports.TAB_SIZES = TAB_SIZES;
var GridSelector = {
  ROW: 'tr, [role="row"]',
  HEADER: 'th',
  CELL: 'td, [role="gridcell"]',
  FOCUSABLE: 'input:enabled, select, textarea, a[href], button, [role="button"], [tabindex]',
  EDITABLE: 'input:enabled[type="text"], input:enabled[type="number"], select, textarea',
  HAS_ENTER_KEY_HANDLING: 'a, button, textarea'
};
exports.GridSelector = GridSelector;
var OBJECT_STATUS_SIZES = ['l'];
exports.OBJECT_STATUS_SIZES = OBJECT_STATUS_SIZES;
var OBJECT_STATUS_TYPES = ['negative', 'critical', 'positive', 'informative'];
exports.OBJECT_STATUS_TYPES = OBJECT_STATUS_TYPES;
var DATEPICKER_TODAY_ACTIONS_TYPES = ['none', 'select', 'navigate'];
exports.DATEPICKER_TODAY_ACTIONS_TYPES = DATEPICKER_TODAY_ACTIONS_TYPES;
var SCREEN_SIZE_MAP = {
  'smallScreen': 'col--',
  'mediumScreen': 'col-md--',
  'largeScreen': 'col-lg--',
  'xLargeScreen': 'col-xl--'
};
exports.SCREEN_SIZE_MAP = SCREEN_SIZE_MAP;
var TREE_NODE_HIGHLIGHTS = ['default', 'error', 'success', 'warning'];
exports.TREE_NODE_HIGHLIGHTS = TREE_NODE_HIGHLIGHTS;